import { useEffect } from 'react';
import { useBeforeUnload } from 'react-router-dom';
import { useGroupChannels } from '../chat/chatSlice';
import { useFilteredTotalUnreadMessageCount } from '../fleetGroupFilter/useFilteredChats';
import useTabActive from '../../hooks/useTabActive';
import { useSendbirdApi } from '../../sendbird/useSendbirdApi';
import { sendWindowMessage } from '../../services/sendWindowMessage';

export const MessageHandler = () => {
    const isBrowserTabActive = useTabActive();
    const groupChannels = useGroupChannels();
    const totalUnreadMessageCount = useFilteredTotalUnreadMessageCount(groupChannels);

    const { disconnect, reconnect } = useSendbirdApi();

    useBeforeUnload(_ => {
        disconnect().catch(console.error);
    });

    useEffect(() => {
        sendWindowMessage({
            type: 'EVENT_WIDGET_CHAT_TOTAL_UNREAD_MESSAGE_COUNT_CHANGED',
            payload: totalUnreadMessageCount,
        });
    }, [totalUnreadMessageCount]);

    useEffect(() => {
        console.log('isBrowserTabActive', isBrowserTabActive);
        if (isBrowserTabActive) {
            reconnect().catch(console.error);
        } else {
            disconnect().catch(console.error);
        }
    }, [isBrowserTabActive]);

    return null;
};
